import { render, staticRenderFns } from "./NewsListcomponent.vue?vue&type=template&id=f0a018a0"
import script from "./NewsListcomponent.vue?vue&type=script&lang=js"
export * from "./NewsListcomponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports